import { ReactNode } from 'react'
import { Checkbox, CheckboxProps } from '../../form'
import { cn } from '../../../utils'

export interface AuftragCheckboxProps extends CheckboxProps {
  className?: string
  children?: ReactNode
  noInteraction?: boolean
  hideKennung?: boolean
  readOnly?: boolean
  inline?: boolean
}

/**
 * A checkbox component specifically for Auftrag forms.
 */
export default function AuftragCheckbox({
  className,
  children,
  readOnly = false,
  inline = false,
  label,
  'data-testid': testId,
  ...checkboxProps
}: Readonly<AuftragCheckboxProps>) {
  const checkbox = (
    <Checkbox
      {...checkboxProps}
      hideLabel={true}
      className={cn({ 'pointer-events-none !opacity-100': readOnly })}
      readOnly={readOnly}
      label={label}
      data-testid={`${testId}-checkbox`}
    />
  )

  return (
    <div
      className={cn(
        'flex items-center',
        {
          'flex-col': !inline,
          'gap-1': inline
        },
        className
      )}
      aria-readonly={readOnly ? 'true' : 'false'}
    >
      {inline ? (
        checkbox
      ) : (
        <div className="w-full flex items-center justify-center">
          {checkbox}
        </div>
      )}
      <span
        className={cn({
          'text-center w-full whitespace-nowrap': !inline
        })}
        aria-hidden="true"
        data-testid={`${testId}-label`}
      >
        {label}
      </span>
      {children}
    </div>
  )
}
